import { Component, Input, OnChanges, SimpleChange, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PreviewExternalSettingsComponent } from 'src/app/core/components/preview-external-settings/preview-external-settings.component';
import { Entity } from 'src/app/core/models/entity.model';
import { SettingsFitMade4U } from 'src/app/core/models/settings.model';
import { User } from 'src/app/core/models/user.model';
import { EntityService } from 'src/app/core/services/entity.service';
import { SettingsService } from 'src/app/core/services/settings.service';
import { FileSpecsService } from 'src/app/core/services/file-specs.service';
import * as utils from 'src/app/shared/helpers/utils';

@Component({
  selector: 'hbo-setting-fitmade4u',
  templateUrl: './setting-fitmade4u.component.html',
  styleUrls: ['./setting-fitmade4u.component.scss']
})
export class SettingFitmade4uComponent implements OnChanges {

  @Input() entity!: Entity;
  @Input() isOpen = false;
  @Input() entityApps: number[] = [];


  @ViewChild('externalSettings') externalSettings!: PreviewExternalSettingsComponent;

  actualFilenames: { [key: string]: string } = {};

  public utils = utils;

  showSettings = false;
  currentSettings?: SettingsFitMade4U;

  user: User = utils?.localStorageGetItem('user');

  settingsForm = this.formBuilder.nonNullable.group({
    // común
    language: ['es'],

    // fit-made4U
    fittingHeight: [''],
    fitmade4uLogo1: [''],
    logo1Allow: [false],
    fitmade4uLogo2: [''],
    LOPDdataProcessor: [''],
    LOPDName: [''],
    LOPDEmail: [''],
    screenSaverEnabled: [false],
    screenSaverFileName: [''],
    screenSaverMimeType: [''],
    screenSaverVideo: [''],
    screenSaverVideoData: [''],
    limitedBandwidth: [false],
    allowDelete: [false],

    // fit
    fitAppName: ['FIT'],
    logoA: [''],
    externalReporting: [''],
    externalReportingUser: [''],
    technologies: this.formBuilder.group({
      boxIA: [false],
      corridor: [false],
      nearpd: [false],
    }),

    // made4U
    made4uAppName: ['MADE4YOU'],
    logoB: [''],
    catalogs: this.formBuilder.group({
      mimic: [false],
      liqRX: [false],
      liq: [false],
      basic: [false],
    }),
    managementOrders: this.formBuilder.group({
      specialRates: this.formBuilder.group({
        uniformity: [false],
        vip: [false],
      }),
      validatorEmail: ['', Validators.email],
      reminderEmail: ['', Validators.email],
    }),
    shippingAddress: this.formBuilder.group({
      address: [''],
      country: [''],
      cityAndZipCode: [''],
    }),
  });
  screenSaverVideo!: File;
  hierarchy!: any;

  constructor(
    private formBuilder: FormBuilder,
    private settingsService: SettingsService,
    private entityService: EntityService,
    private fileSpecsService: FileSpecsService
  ) { }


  ngOnChanges(changes: { [property: string]: SimpleChange }) {
    if (changes['isOpen']?.currentValue) {
      this.showSettings = false;
      this.setSettingsAncestor().then(res => {
        this.hierarchy = res.base64;
        //this.settingsService.get(this.entity.id, 5, this.hierarchy).subscribe(
        this.settingsService.getInvision(this.entity.internalCode, this.hierarchy, this.entity.entityTypeId).subscribe(
          res => {
            this.showSettings = true;
            this.setForm(res)
          },
          err => {
            if (err.status == 404) {
              this.settingsService.updateInvision(this.entity.internalCode ? this.entity.internalCode : this.entity.id, this.hierarchy, this.entity.entityTypeId, { "settings": { "timezone": this.entity.timezone } }).subscribe(
                res => {
                  this.settingsService.getInvision(this.entity.internalCode, this.hierarchy, this.entity.entityTypeId).subscribe(
                    res => {
                      this.showSettings = true;
                      this.setForm(res)
                    },
                    err => {
                      console.log("errorrrr", err);
                      console.log(err.status)
                      this.showSettings = true;
                      this.setForm(this.initSettingsFitMade4u())
                    }
                  )
                },
                err => {
                  console.log("errorrrr", err);
                  console.log(err.status)
                  this.showSettings = true;
                  this.setForm(this.initSettingsFitMade4u())
                }
              )
            }else{
              console.log("errorrrr", err);
              console.log(err.status)
              this.showSettings = true;
              this.setForm(this.initSettingsFitMade4u())
            }
          }
        );
      });
    }
  }
  
  setSettingsAncestor(): Promise<{ data: any; base64: string }> {
    return new Promise((resolve, reject) => {
      this.entityService.getAncestor(this.entity).subscribe(
        async res => {
          let parentEntity = res.parentEntity;
          let object = {
            "hierarchy": {
              "shop_id": String(this.entity.internalCode ? this.entity.internalCode : this.entity.id),
              "ancestor": this.entity?.entityTypeId != 1
              ? {
                "shop_id": String(parentEntity?.internalCode ? parentEntity?.internalCode : parentEntity?.id),
                "ancestor": this.entity?.entityTypeId != 2
                  ? {
                    "shop_id": String(parentEntity?.parentEntity?.internalCode ? parentEntity?.parentEntity?.internalCode : parentEntity?.parentEntity?.id),
                    "ancestor": parentEntity?.parentEntity?.entityTypeId == 2
                      ? {
                        "shop_id": String(parentEntity?.parentEntity?.parentEntity?.internalCode ? parentEntity?.parentEntity?.parentEntity?.internalCode : parentEntity?.parentEntity?.parentEntity?.id),
                        "ancestor": null
                      }
                      : null
                  }
                  : null
                }
              : null
            }
          }
          resolve({ data: object, base64: utils.objectToBase64(object) });
          //resolve({ data: object, base64: utils.objectToBase64(object) });
        });
    });
  }


  cleanParams(originalParams: any) {
    const cleanProps: any = {};
    // Recorrer las propiedades del objeto original para copiarlas al nuevo objeto
    for (const key in originalParams) {
      // Solo copiar la propiedad si tiene valor
      if (originalParams[key] || originalParams[key] === false || originalParams[key] === "") {
        if (typeof originalParams[key] === 'object' && !(originalParams[key] instanceof Array)) {
          // Si la propiedad es un objeto se llama recursivamente a esta funcion con esta propiedad y se asigna el resultado
          const cleanProp: object = this.cleanParams(originalParams[key]);
          if (Object.keys(cleanProp).length) {
            cleanProps[key] = cleanProp;
          }
        } else {
          // Si la propiedad no es un objeto se asigna directamente
          cleanProps[key] = originalParams[key];
        }
      }
    }
    return cleanProps;
  }

  async preview() {
    this.externalSettings.showPreview({
      app: 'fit-made4u',
      logo1: this.settingsForm.get('fitmade4uLogo1')?.value ? await utils.toBase64('fitmade4uLogo1', this.entity.id) : this.currentSettings?.appFrontendDesign?.logo1?.logoImage ?? '',
      logo2: this.settingsForm.get('fitmade4uLogo2')?.value ? await utils.toBase64('fitmade4uLogo2', this.entity.id) : this.currentSettings?.appFrontendDesign?.logo2?.logoImage ?? '',
      logoA: this.entityApps.includes(5)
        ? this.settingsForm.get('logoA')?.value
          ? await utils.toBase64('logoA', this.entity.id)
          : (this.currentSettings?.appFrontendDesign?.fit?.logoImage ? this.currentSettings.appFrontendDesign.fit.logoImage : '')
        : '',
      fitName: this.entityApps.includes(5) ? this.settingsForm.value.fitAppName! : '',
      logoB: this.entityApps.includes(6)
        ? this.settingsForm.get('logoB')?.value
          ? await utils.toBase64('logoB', this.entity.id)
          : (this.currentSettings?.appFrontendDesign?.m4u?.logoImage ? this.currentSettings.appFrontendDesign.m4u.logoImage : '')
        : '',
      m4uName: this.entityApps.includes(6) ? this.settingsForm.value.made4uAppName!: ''
    })
  }


  getTouchedValues(form: any) {
    let touchedValues: { [key: string | number]: any } = {};

    Object.keys(form.controls)
      .forEach(key => {
        let currentControl = form.controls[key];

        if (currentControl.touched) {
          if (currentControl.controls)
            touchedValues[key] = this.getTouchedValues(currentControl);
          else
            touchedValues[key] = currentControl.value;
        }
      });

    return touchedValues;
  }

  /*setUntochedValues(form: any) {
    Object.keys(form.controls)
      .forEach(key => {
        let currentControl = form.controls[key];
        if (currentControl.touched) {
          if (currentControl.controls)
            touchedValues[key] = this.getTouchedValues(currentControl);
          else
            currentControl.to
            touchedValues[key] = currentControl.value;
        }
      });

    return touchedValues;
  }*/

  async submit() {
    const update: SettingsFitMade4U = {
      language: this.settingsForm.value.language!,
      fittingHeight: this.settingsForm.value.fittingHeight!,
      limitedBandwidth: this.settingsForm.value.limitedBandwidth!,
      appFrontendDesign: {
        fit: {
          logoImage: this.settingsForm.get('logoA')?.value && this.currentSettings?.appFrontendDesign?.fit?.logoImage
            ? (await utils.toBase64('logoA', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.fit?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.fit?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.get('logoA')?.value && this.currentSettings?.appFrontendDesign?.fit?.logoName
            ? (this.settingsForm.get('logoA')?.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.fit?.logoName ?? '',
          appName: this.settingsForm.value.fitAppName!,
        },
        m4u: {
          logoImage: this.settingsForm.get('logoB')?.value && this.currentSettings?.appFrontendDesign?.m4u?.logoImage
            ? (await utils.toBase64('logoB', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.m4u?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.m4u?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.controls.logoB.value && this.currentSettings?.appFrontendDesign?.m4u?.logoName
            ? (this.settingsForm.controls.logoB.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.m4u?.logoName ?? '',
          appName: this.settingsForm.value.made4uAppName!,
        },
        logo1: {
          logoImage: this.settingsForm.get('fitmade4uLogo1')?.value && this.currentSettings?.appFrontendDesign?.logo1?.logoImage
          ? (await utils.toBase64('fitmade4uLogo1', this.entity.id)).replace(',', ", ")
          : (this.currentSettings?.appFrontendDesign?.logo1?.logoImage?.replace(',', ", ")
          ? this.currentSettings?.appFrontendDesign?.logo1?.logoImage?.replace(',', ", ")
            : ''),
          logoName: this.settingsForm.controls.fitmade4uLogo1.value && this.currentSettings?.appFrontendDesign?.logo1?.logoName
            ? (this.settingsForm.controls.fitmade4uLogo1.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.logo1?.logoName ?? '',
          allowConfiguration:  this.settingsForm.controls.logo1Allow.value,
        },
        logo2: {
          logoImage: this.settingsForm.get('fitmade4uLogo2')?.value && this.currentSettings?.appFrontendDesign?.logo2?.logoImage
          ? (await utils.toBase64('fitmade4uLogo2', this.entity.id)).replace(',', ", ")
          : (this.currentSettings?.appFrontendDesign?.logo2?.logoImage?.replace(',', ", ")
          ? this.currentSettings?.appFrontendDesign?.logo2?.logoImage?.replace(',', ", ")
            : ''),
          logoName: this.settingsForm.controls.fitmade4uLogo2.value && this.currentSettings?.appFrontendDesign?.logo2?.logoName
            ? (this.settingsForm.controls.fitmade4uLogo2.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.logo2?.logoName ?? '',
        },
      },
      dataProtection: {
        dataProcessor: this.settingsForm.value.LOPDdataProcessor!,
        opticalShopName: this.settingsForm.value.LOPDName!,
        opticalShopEmail: this.settingsForm.value.LOPDEmail!,
        allowDelete: this.settingsForm.value.allowDelete!
      },
      screenSaver: {
        enabled: this.settingsForm.value.screenSaverEnabled,
        // OJO
        fileName: this.settingsForm.controls.screenSaverFileName.value && this.currentSettings?.screenSaver?.fileName
        ? (this.currentSettings?.screenSaver?.fileName as string).replace('C:\\fakepath\\', '')
        : this.currentSettings?.screenSaver?.fileName ?? '',
        // OJO
        mimeType: this.currentSettings!.screenSaver?.mimeType,
      },
      technologies: {
        boxIA: this.settingsForm.value.technologies?.boxIA!,
        corridor: this.settingsForm.value.technologies?.corridor!,
        nearpd: this.settingsForm.value.technologies?.nearpd!
      },
      externalReporting: {
        service: this.settingsForm.value.externalReporting!,
        params: {
          userId: this.settingsForm.value.externalReportingUser!
        }
      },
      catalogs: {
        BASICSHAPES: this.settingsForm.value.catalogs?.basic!,
        MIMIC_2017_2018: this.settingsForm.value.catalogs?.mimic!,
        "LIQ-RX_2019": this.settingsForm.value.catalogs?.liqRX!,
        LIQ_2019: this.settingsForm.value.catalogs?.liq!,
      },
      managementOrders: {
        specialRates: {
          uniformity: this.settingsForm.value.managementOrders!.specialRates?.uniformity!,
          vip: this.settingsForm.value.managementOrders!.specialRates?.vip!
        },
        validatorEmail: this.settingsForm.value.managementOrders!.validatorEmail!,
        reminderEmail: this.settingsForm.value.managementOrders!.reminderEmail!
      },
      shippingAddress: {
        country: this.settingsForm.value.shippingAddress!.country!,
        address: this.settingsForm.value.shippingAddress!.address!,
        cityAndZipCode: this.settingsForm.value.shippingAddress!.cityAndZipCode!,
      },
      timezone: this.entity.timezone
    }


    //do not send image once it has been eliminated and the control form has not been touched
    let touchedControls = this.getTouchedValues(this.settingsForm);
    let imagesTouched: string[] = ['fitmade4uLogo1', 'fitmade4uLogo2', 'logoA', 'logoB', 'screenSaverVideo'];
    imagesTouched.map(image => {
      switch (image) {
        case 'fitmade4uLogo1':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.logo1?.logoImage && delete update.appFrontendDesign.logo1?.logoName
          // if (touchedControls[name] === undefined) delete update.appFrontendDesign.logo1?.logoName
          break;
        case 'fitmade4uLogo2':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.logo2?.logoImage && delete update.appFrontendDesign.logo2?.logoName
          break;
        case 'logoA':
          //if (touchedControls[image] !== undefined) update.appFrontendDesign.fit!.logoChanged = true
          if (touchedControls[image] === undefined && touchedControls['fitAppName'] === undefined) delete update.appFrontendDesign.fit;
          break;
        case 'logoB':
          //if (touchedControls[image] !== undefined) update.appFrontendDesign.m4u!.logoChanged = true;
          if (touchedControls[image] === undefined && touchedControls['m4uName'] === undefined) delete update.appFrontendDesign.m4u;
          break;
        case 'screenSaverVideo':
          if (touchedControls[image] === undefined) delete update.screenSaverVideo && delete update.screenSaverVideoData;
          // if (touchedControls[name] === undefined) delete update.appFrontendDesign.logo1?.logoName
          break;
        default:
          break;
      }
    })
    this.showSettings = false;
    const data_to_update =  {"settings": this.cleanParams(update)}
    const video_data = {"size": this.currentSettings?.screenSaver?.size, "mimeType":this.currentSettings?.screenSaver?.mimeType}

    this.settingsService.updateInvision(this.entity.internalCode, this.hierarchy, this.entity.entityTypeId, data_to_update).subscribe(res => {
      if (touchedControls["screenSaverVideo"] !== undefined && this.currentSettings?.screenSaverVideo){
        this.settingsService.updateInvisionScreenSaver(this.entity.internalCode, video_data).subscribe(res => {
          this.settingsService.putScreenSaver(res["url"], this.currentSettings?.screenSaverVideo).subscribe(res => {console.log(res)})
        });
      }
      this.showSettings = true;
      this.settingsForm.markAsUntouched();
    });
  }

  setForm(res: SettingsFitMade4U) {
    this.currentSettings = res;

    this.settingsForm.patchValue({
      // común
      language: res.language,

      // fit-made4U
      limitedBandwidth: res.limitedBandwidth,
      fittingHeight: res.fittingHeight,
      fitmade4uLogo1: '',
      logo1Allow: res.appFrontendDesign?.logo1?.allowConfiguration,
      fitmade4uLogo2: '',
      LOPDdataProcessor: res.dataProtection?.dataProcessor,
      LOPDName: res.dataProtection?.opticalShopName,
      LOPDEmail: res.dataProtection?.opticalShopEmail,
      screenSaverEnabled: res.screenSaver?.enabled,
      screenSaverFileName: res.screenSaver?.fileName!,
      screenSaverMimeType: res.screenSaver?.mimeType!,
      screenSaverVideo: '',
      allowDelete: res.dataProtection?.allowDelete,

      // fit
      fitAppName: res.appFrontendDesign?.fit?.appName,
      logoA: '',
      externalReporting: res.externalReporting?.service,
      externalReportingUser: res.externalReporting?.params?.userId,
      technologies: {
        boxIA: res.technologies?.boxIA,
        corridor: res.technologies?.corridor,
        nearpd: res.technologies?.nearpd
      },

      // made4U
      made4uAppName: res.appFrontendDesign?.m4u?.appName,
      logoB: '',
      catalogs: {
        mimic: res.catalogs?.MIMIC_2017_2018,
        liqRX: res.catalogs?.['LIQ-RX_2019'],
        liq: res.catalogs?.LIQ_2019,
        basic: res.catalogs?.BASICSHAPES,
      },
      managementOrders: {
        specialRates: {
          uniformity: res.managementOrders?.specialRates?.uniformity,
          vip: res.managementOrders?.specialRates?.vip
        },
        validatorEmail: res.managementOrders?.validatorEmail,
        reminderEmail: res.managementOrders?.reminderEmail
      },
      shippingAddress: {
        address: res.shippingAddress?.address,
        country: res.shippingAddress?.country,
        cityAndZipCode: res.shippingAddress?.cityAndZipCode,
      }
    });

    if (this.entity.id === this.user.entityId && this.user.profileId !== 3 && !(this.user.roleId === 4 && this.user.profileId === 1)) {
      this.settingsForm.disable();
    }
  }

  showImage(e: Event, _image?: string) {
    e.preventDefault();
    const image = new Image();
    image.src = _image!;
    image.style.maxWidth = '40%';
    image.style.margin = '20px';
    const w = window.open("", "_blank");
    w!.document.write(
      "<div style='background-color: #212121; width: 100%; height: 100%; margin: -8px;'>" + image.outerHTML + "</div>"
    );
  }

  showVideo(e: Event, _image?: string) {
    e.preventDefault();
    const w = window.open("", "_blank");
    w!.document.write(
      "<html style='margin: 0; padding: 0; overflow: hidden;'>" +
      "<body style='margin: 0; padding: 0; background-color: #212121; width: 100vw; height: 100vh; display: flex; justify-content: center; align-items: center; overflow: hidden;'>" +
      "<video style='width: 100%; height: 100%; object-fit: contain;' controls>" +
      "<source src='" + _image + "' type='video/mp4'>" +
      "<source src='" + _image + "' type='video/ogg'>" +
      "Your browser does not support the video tag." +
      "</video>" +
      "</body></html>"
    );
  }

  clearImage(e: Event, image?: string) {
    e.preventDefault();

    this.settingsForm.get(image?.split('-')[0] as any)?.patchValue('');
    this.settingsForm.get(image?.split('-')[0] as any)?.markAsTouched({ onlySelf: true });

    //let touchedContols = this.getTouchedValues(this.settingsForm);
    this.deleteSettingsObjectImage(image!);
    // switch (image) {
    //   case 'logo1':
    //     this.deleteSettingsObjectImage(image);
    //     break;
    //   case 'logo2':
    //     this.deleteSettingsObjectImage(image);
    //     break;
    //   case 'logoA':
    //     this.deleteSettingsObjectImage(image);
    //     break;
    //   case 'logoB':
    //     this.deleteSettingsObjectImage(image);
    //     break;
    //   case 'screenSaver':
    //     this.deleteSettingsObjectImage(image);
    //     break
    //   default:
    //     break;
    // }
  }
  deleteSettingsObjectImage(_attr: number | string) {
    /*Object.keys(this.currentSettings!.appFrontendDesign.logo).reduce((result: { [key: string | number]: any }, key: number | string) => {
      if (Number(key) !== _attr) {
        delete this.currentSettings!.appFrontendDesign.logo[_attr].image;
        delete this.currentSettings!.appFrontendDesign.logo[_attr].name
      }
      return result;
    }, {})*/
    switch (_attr) {
      case 'fitmade4uLogo1':
        Object.keys(this.currentSettings!.appFrontendDesign.logo1!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.logo1 = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.logo1!)
          }
          return result;
        }, {})
        break;
      case 'fitmade4uLogo2':
        Object.keys(this.currentSettings!.appFrontendDesign.logo2!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.logo2 = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.logo2!)
          }
          return result;
        }, {})
        break;
      case 'logoA':
        Object.keys(this.currentSettings!.appFrontendDesign.fit!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.fit = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.fit!)
          }
          return result;
        }, {})
        break;
      case 'logoB':
        Object.keys(this.currentSettings!.appFrontendDesign.m4u!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.m4u = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.m4u!)
          }
          return result;
        }, {})
        break;
      case 'screenSaverVideo':
        this.currentSettings!.screenSaver = {
          enabled: this.currentSettings!.screenSaver?.enabled!,
          fileName: "",
          mimeType: ""
        } ;
        this.currentSettings!.screenSaverVideo = '';
        this.currentSettings!.screenSaverVideoData = '';
        break;
    }
  }
  setSettingsObjectImage(_attr: number | string, _name: string, _image: string) {
    switch (_attr) {
      case 'fitmade4uLogo1':
        !this.currentSettings!.appFrontendDesign.logo1 ? this.currentSettings!.appFrontendDesign.logo1 = { allowConfiguration: false } : null;
        this.currentSettings!.appFrontendDesign.logo1.logoImage = _image;
        this.currentSettings!.appFrontendDesign.logo1.logoName = _name;
        break;
      case 'fitmade4uLogo2':
        !this.currentSettings!.appFrontendDesign.logo2 ? this.currentSettings!.appFrontendDesign.logo2 = { logoName: _name } : null;
        this.currentSettings!.appFrontendDesign.logo2.logoImage = _image;
        this.currentSettings!.appFrontendDesign.logo2.logoName = _name;
        break;
      case 'logoA':
        !this.currentSettings!.appFrontendDesign.fit ? this.currentSettings!.appFrontendDesign.fit = { appName: 'FIT APP NAME' } : null;
        this.currentSettings!.appFrontendDesign.fit.logoImage = _image;
        this.currentSettings!.appFrontendDesign.fit.logoName = _name;
        break;
      case 'logoB':
        !this.currentSettings!.appFrontendDesign.m4u ? this.currentSettings!.appFrontendDesign.m4u = { appName: 'FIT APP NAME' } : null;
        this.currentSettings!.appFrontendDesign.m4u.logoImage = _image;
        this.currentSettings!.appFrontendDesign.m4u.logoName = _name;
        break;
    }

  }

  getFileNameFromPath(_path: String, _file?: string) {
    this.actualFilenames[_file!] = _path.replace(/^.*[\\/]/, '');
  }

  async uploadFile(event: Event, _name: string) {   
    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;
    
    // Verificar que hay archivos seleccionados
    if (!fileList || fileList.length === 0) {
      return;
    }
    
    const file = fileList[0];
    const control = this.settingsForm.get(_name);
    
    if (!control) return;
    
    // Validar con el servicio centralizado
    if (!this.fileSpecsService.validateAndSetFormControl(_name, file, control, element)) {
      return;
    }
    
    /*if (this.entity.entityTypeId == 1) {
      let file = fileList[0];
      let blob = file.slice(0, file.size, 'image/png');
      let newFile = new File([blob], _name + '.png', { type: 'image/png' });
      this.getFileNameFromPath(newFile.name, _name);
    } else {*/
    this.getFileNameFromPath(fileList[0].name, _name);
    
    let idObject: string | number = ''
    idObject = _name;
    // switch (_name) {
    //   case "screenSaverVideo":
    //     idObject = _name;
    //     break;
    //   case 'logo1':
    //     idObject = _name;
    //     break;
    //   case 'logo2':
    //     idObject = _name;
    //     break;
    //   case 'logoA':
    //     idObject = _name;
    //     break
    //   case 'logoB':
    //     idObject = _name;
    //     break;
    //   default:
    //     break;
    // }
    if(idObject== 'screenSaverVideo'){
      !this.currentSettings!.screenSaver ? this.currentSettings!.screenSaver = { enabled: false } : null;
      this.currentSettings!.screenSaverVideo = fileList![0];
      this.currentSettings!.screenSaverVideoData = await utils.toBase64(_name, this.entity.id);
      this.currentSettings!.screenSaver.fileName = fileList![0].name;
      this.currentSettings!.screenSaver.size = fileList![0].size
      this.currentSettings!.screenSaver.mimeType = fileList![0].type
    } else{
      this.setSettingsObjectImage(idObject, this.actualFilenames[_name], await utils.toBase64(_name, this.entity.id))
    }
    // if(_name == "screenSaverVideo"){
    //   this.currentSettings!.screenSaverVideoData = fileList![0]
    // }
  }

  initSettingsFitMade4u(): SettingsFitMade4U {
    let settingsFitMade4u = new SettingsFitMade4U();
    settingsFitMade4u = {
      language: '',
      fittingHeight: '',
      limitedBandwidth: false,
      appFrontendDesign: {
        fit: {
          logoImage: '',
          logoName: '',
          appName: '',
        },
        m4u: {
          logoImage: '',
          logoName: '',
          appName: '',
        },
        logo1: {
          logoImage: '',
          logoName: '',
          allowConfiguration: false,
        },
        logo2: {
          logoImage: '',
          logoName: '',
        },
      },
      dataProtection: {
        dataProcessor: '',
        opticalShopName: '',
        opticalShopEmail: '',
        allowDelete: false,
      },
      screenSaver: {
        enabled: false,
        fileName: '',
        mimeType: '',
      },
      technologies: {
        boxIA: false,
        corridor: false,
        nearpd: false
      },
      externalReporting: {
        service: '',
        params: {
          userId: '',
        }
      },
      catalogs: {
        BASICSHAPES: false,
        MIMIC_2017_2018: false,
        "LIQ-RX_2019": false,
        LIQ_2019: false,
      },
      managementOrders: {
        specialRates: {
          uniformity: false,
          vip: false
        },
        reminderEmail: '',
        validatorEmail: ''
      },
      shippingAddress: {
        country: '',
        address: '',
        cityAndZipCode: ''
      }
    }
    return settingsFitMade4u
  }


}
